var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.ModuleContainer, {
    scopedSlots: _vm._u([
      {
        key: "draggable",
        fn: function (props) {
          return [
            _c(
              _setup.DraggablePopup,
              _vm._b(
                {
                  attrs: {
                    show: _setup.c_show,
                    width: 400,
                    height: 300,
                    title: _setup.$map.trans("map.layer-control.create.title"),
                  },
                  on: {
                    "update:show": function ($event) {
                      _setup.c_show = $event
                    },
                    close: _setup.close,
                  },
                },
                "DraggablePopup",
                props,
                false
              ),
              [
                _c(
                  "div",
                  { staticClass: "create-control-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "form-container" },
                      [
                        _c(
                          _setup.component_config,
                          {
                            key: _setup.key_render,
                            tag: "component",
                            staticClass: "create-control-form",
                            model: {
                              value: _setup.form.config,
                              callback: function ($$v) {
                                _vm.$set(_setup.form, "config", $$v)
                              },
                              expression: "form.config",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "map-col-12" },
                              [
                                _c(_setup.inputText, {
                                  attrs: {
                                    label: _setup.$map.trans(
                                      "map.layer-control.field.name"
                                    ),
                                  },
                                  model: {
                                    value: _setup.form.config.name,
                                    callback: function ($$v) {
                                      _vm.$set(_setup.form.config, "name", $$v)
                                    },
                                    expression: "form.config.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "map-col-12" },
                              [
                                _c(_setup.inputSelect, {
                                  attrs: {
                                    items: _setup.items_type,
                                    label: _setup.$map.trans(
                                      "map.layer-control.field.type"
                                    ),
                                  },
                                  on: { input: _setup.onChangeType },
                                  model: {
                                    value: _setup.form.type,
                                    callback: function ($$v) {
                                      _vm.$set(_setup.form, "type", $$v)
                                    },
                                    expression: "form.type",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      _setup.baseButton,
                      {
                        staticClass: "btn-container",
                        on: {
                          click: function ($event) {
                            return _setup.onAddLayer(_setup.form)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _setup.$map.trans("map.layer-control.create-btn")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }